import React, { useEffect, createRef, useRef } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { utilities } from "@/_helpers";
import "./GoogleMaps.css";

const GOOGLE_MAP_API_KEY = process.env.REACT_APP_GOOGLE_KEY;

export const GoogleMaps = ({
  defaultCenter,
  locationMarkers,
  locations,
  selectedLocation,
}) => {
  const { t } = useTranslation();
  const googleMapRef = createRef();
  const googleMap = useRef(null);
  const marker = useRef(null);
  const createGoogleMap = () => {
    googleMap.current = new window.google.maps.Map(
      document.getElementById("google-map"),
      {
        zoom: 10,
        center: defaultCenter,
        mapTypeControl: false,
        streetViewControl: false,
      }
    );
  };
  const updateGoogleMap = () => {
    let legend = document.getElementById("legend");
    let center = new window.google.maps.LatLng(
      defaultCenter.lat,
      defaultCenter.lng
    );
    googleMap.current.panTo(center);
    googleMap.current.controls[
      window.google.maps.ControlPosition.RIGHT_BOTTOM
    ].push(legend);
  };
  const createMarker = () => {
    let markerIcon = {
      url: "./src/_images/LocationsIcon.png",
      scaledSize: new window.google.maps.Size(50, 50),
      origin: new window.google.maps.Point(0, 0),
      anchor: new window.google.maps.Point(0, 15),
    };
    let sameDayIcon = {
      url: "./src/_images/SameDayIcon.png",
      scaledSize: new window.google.maps.Size(50, 50),
      origin: new window.google.maps.Point(0, 0),
      anchor: new window.google.maps.Point(0, 15),
    };

    const infoWindow = new window.google.maps.InfoWindow();

    locationMarkers.forEach((loc) => {
      let thisIcon = markerIcon;
      if (loc.sameDay === true) {
        thisIcon = sameDayIcon;
      }

      const marker = new window.google.maps.Marker({
        key: loc.key,
        title: loc.title,
        animation: window.google.maps.Animation.DROP,
        position: { lat: loc.lat, lng: loc.lng },
        map: googleMap.current,
        icon: thisIcon,
      });

      let selectBtn = document.createElement("button");
      selectBtn.innerHTML = t("appointments.select");
      selectBtn.id = loc.key;
      selectBtn.style.backgroundColor = "#76bc21";
      selectBtn.style.color = "#fff";

      // Add a click listener for each marker, and set up the info window.
      marker.addListener("click", () => {
        infoWindow.close();
        infoWindow.setContent(infoWindowContent(loc, selectBtn));
        infoWindow.open(marker.getMap(), marker);
      });

      window.google.maps.event.addDomListener(selectBtn, "click", (e) => {
        let locationInfo = locations.find(
          (x) => x.locationID === parseInt(e.srcElement.id)
        );
        selectedLocation(locationInfo);
      });
    });
  };
  const clearMarker = () => {
    const marker = new window.google.maps.Marker();
    marker.setMap(null);
  };
  const infoWindowContent = (selectedLoc, inputEl) => {
    let locationInfo = locations.find((x) => x.locationID === selectedLoc.key);
    let mainHeader = document.createElement("h2");
    mainHeader.innerHTML = locationInfo.displayName;
    let mainDiv = document.createElement("div");
    mainDiv.className = "description";
    let locDescription = document.createElement("p");
    locDescription.className = "removeMargin";
    locDescription.innerHTML =
      locationInfo.address1 +
      " " +
      (locationInfo.address2 && locationInfo.address2.length > 0
        ? locationInfo.address2
        : "");
    let locDescription2 = document.createElement("p");
    locDescription2.className = "removeMargin";
    locDescription2.innerHTML =
      locationInfo.city + ", " + locationInfo.state + " " + locationInfo.zip;
    let locDescription3 = document.createElement("p");
    locDescription3.className = "removeMargin";
    locDescription3.innerHTML = utilities.formatPhoneNumber(
      locationInfo.phone1
    );
    mainDiv.appendChild(locDescription);
    mainDiv.appendChild(locDescription2);
    mainDiv.appendChild(locDescription3);
    mainHeader.append(mainDiv);
    mainHeader.append(inputEl);

    return mainHeader;
  };

  useEffect(() => {
    const googleMapScript = document.createElement("script");
    googleMapScript.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAP_API_KEY}&libraries=places`;
    window.document.body.appendChild(googleMapScript);

    googleMapScript.addEventListener("load", () => {
      createGoogleMap();
      marker.current = createMarker();
    });
  }, []);

  useEffect(() => {
    if (googleMap.current !== null) {
      updateGoogleMap();
      if (locationMarkers.length === 0) {
        // Remove Locations
        marker.current = clearMarker();
      }
      if (locationMarkers.length > 0) {
        marker.current = createMarker();
      }
    }
  }, [locationMarkers]);

  return <div id="google-map" ref={googleMapRef} className="mapStyles" />;
};

GoogleMaps.propTypes = {
  defaultCenter: PropTypes.object.isRequired,
  locationMarkers: PropTypes.array,
  locations: PropTypes.array,
  selectedLocation: PropTypes.func.isRequired,
};
